"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../../../Constant");

var _theme, _theme2;

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 8px;\n  cursor: pointer;\n  font-size: 1.6rem;\n  color: ", ";\n\n  &:hover,\n  &[role='option'][aria-selected='true'] {\n    ", "\n    ", "\n    /* Visible outline for high contrast mode */\n    outline: 2px solid transparent;\n  }\n\n  /* AddressInput uses strong and small elements */\n  &:hover > strong,\n  &:hover > small,\n  &[role='option'][aria-selected='true'] > strong,\n  &[role='option'][aria-selected='true'] > small {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var selectedTextColor = (0, _styledTheming.default)('mode', (_theme = {
  caliber: "color: ".concat(_Constant.Color.WHITE, ";")
}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, "color: ".concat(_Constant.Color.WHITE, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, "color: ".concat(_Constant.Color.WHITE, ";")), (0, _defineProperty2.default)(_theme, "homepoint", "color: ".concat(_Constant.Color.WHITE, ";")), (0, _defineProperty2.default)(_theme, "figure", "color: ".concat(_Constant.Color.WHITE, ";")), (0, _defineProperty2.default)(_theme, "pella", "color: ".concat(_Constant.Color.WHITE, ";")), (0, _defineProperty2.default)(_theme, "petersendean", "color: ".concat(_Constant.Color.WHITE, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, "color: ".concat(_Constant.Color.WHITE, ";")), _theme));
var selectedBackgroundColor = (0, _styledTheming.default)('mode', (_theme2 = {
  caliber: "background-color: ".concat(_Constant.Color.CALIBER_BLUE_NEW, ";")
}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, "background-color: ".concat(_Constant.Color.HOMEBRIDGE_BLUE, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, "background-color: ".concat(_Constant.Color.BLACK, ";")), (0, _defineProperty2.default)(_theme2, "homepoint", "background-color: ".concat(_Constant.Color.HOMEPOINT_NAVY, ";")), (0, _defineProperty2.default)(_theme2, "figure", "background-color: ".concat(_Constant.Color.PURPLE_RAIN, ";")), (0, _defineProperty2.default)(_theme2, "pella", "background-color: ".concat(_Constant.Color.PURPLE_RAIN, ";")), (0, _defineProperty2.default)(_theme2, "petersendean", "background-color: ".concat(_Constant.Color.PURPLE_RAIN, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, "background-color: ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";")), _theme2));

var Row = _styledComponents.default.div(_templateObject(), _Constant.Color.BLACK_SOUL, selectedTextColor, selectedBackgroundColor, selectedTextColor);

var TypeaheadRow = function TypeaheadRow(_ref) {
  var handleClick = _ref.handleClick,
      ariaSelected = _ref.ariaSelected,
      children = _ref.children,
      id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(Row, {
    onClick: handleClick,
    role: "option",
    "aria-selected": ariaSelected,
    id: id
  }, children);
};

TypeaheadRow.propTypes = {
  /** aria-selected is set to true when an assistive technology or keyboard user highlights an option. Otherwise, it is set to false. */
  ariaSelected: _propTypes.default.bool.isRequired,
  handleClick: _propTypes.default.func.isRequired,

  /** The input's aria-describedby attribute uses this id to tell assistive technology that an option is visually selected.  */
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired
};
var _default = TypeaheadRow;
exports.default = _default;